import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/js/rem'
import './assets/css/reset.min.css'
import './assets/css/style.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import { wrapResponse, getJSON, postJSON, downloadWrapResponse, formUpload } from './utils/http'
import './tool.js'
// import VConsole from 'vconsole';

// new VConsole();
window.NODE_ENV = process.env.NODE_ENV

Vue.prototype.$resgistShare = (obj,type=1,shareUrl='') => {
  // eslint-disable-next-line no-undef
  wx.config({
    debug: obj.debug||false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: obj.appId, // 必填，公众号的唯一标识
    timestamp: obj.timestamp, // 必填，生成签名的时间戳
    nonceStr: obj.nonceStr, // 必填，生成签名的随机串
    signature: obj.signature,// 必填，签名
    jsApiList: ['updateAppMessageShareData','updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'] // 必填，需要使用的JS接口列表
  });
  let title = ''
  let desc = ''
  let link = ''
  if(type === 1){
    title = '2026年上海共青团圆梦微心愿';
    desc = '愿爱心与您相伴，希望与您同行。';
    link = `${window.location.origin}/index?fromOpenId=${localStorage.getItem('xiwanggongcheng-openid')}`;
  }else{
    title = '我发起了2026年上海共青团圆梦微心愿-拼好愿行动';
    desc = '诚邀您参与拼好愿，为困难青少年完成心愿。';
    link = shareUrl;
  }
  
  // const link = `${window.location.origin}/index`;
  const imgUrl = `${window.location.origin}/share.png`;
  // eslint-disable-next-line no-undef
  wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    // eslint-disable-next-line no-undef
    wx.updateAppMessageShareData({ 
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function () {
        console.log('updateAppMessageShareData-success');
      }
    })
    // eslint-disable-next-line no-undef
    wx.onMenuShareAppMessage({ 
      title, // 分享标题
      desc, // 分享描述
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function () {
        console.log('updateAppMessageShareData-success');
      }
    })
    // eslint-disable-next-line no-undef
    wx.updateTimelineShareData({ 
      title, // 分享标题
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function () {
        console.log('updateTimelineShareData-success')
      }
    })
    // eslint-disable-next-line no-undef
    wx.onMenuShareTimeline({ 
      title, // 分享标题
      link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl, // 分享图标
      success: function () {
        console.log('updateTimelineShareData-success')
      }
    })
  });
  
   
  
  


}

// const baseUrl = 'https://huazhiyuadmin.first315.com';
const baseUrl = '';
Vue.prototype.$http = {
  formUpload,
  get: (url, params = {}) => {
    url = baseUrl+url;
    let showErrorMsg
    if (Object.hasOwnProperty.call(params, showErrorMsg)) {
      showErrorMsg = true
    } else {
      showErrorMsg = params.showErrorMsg
      delete params.showErrorMsg
    }
    return wrapResponse(getJSON(url, params), showErrorMsg)
  },
  getFile: (url, params = {}) => {
    url = baseUrl+url;
    let showErrorMsg
    if (Object.hasOwnProperty.call(params, showErrorMsg)) {
      showErrorMsg = true
    } else {
      showErrorMsg = params.showErrorMsg
      delete params.showErrorMsg
    }
    return downloadWrapResponse(getJSON(url, params, { responseType: 'blob' }), showErrorMsg)
  },
  post: (url, params = {}, options = {}) => {
    url = baseUrl+url;
    let showErrorMsg
    if (Object.hasOwnProperty.call(params, showErrorMsg)) {
      showErrorMsg = true
    } else {
      showErrorMsg = params.showErrorMsg
      delete params.showErrorMsg
    }
    return wrapResponse(postJSON(url, params, options), showErrorMsg)
  }
}

Vue.use(Vant);



Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
